module.exports = "<div ng-show=\"$ctrl.isVisible()\" class=\"ajax-loader\"></div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/gmao-wait-spinner.html
// module id = 305
// module chunks = 1